const InsuranceChallenge1HintsText =
    ["There are 3 items that should end up in the 'not covered by your insurance' column.",
     "If there is damage to your car, it is not covered by Home Insurance even " +
        "if your car is parked in your driveway",
     "If you live in an apartment, your insurance does not cover damages to " +
         "the building exterior.  This is the responsibility of the landlord.",
     "Your auto insurance does not cover speeding tickets (that's on you)."
    ]

export default InsuranceChallenge1HintsText;